import React, {useState, useEffect} from 'react';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Grid
} from '@material-ui/core';
import {Delete, Edit} from '@material-ui/icons';
import api from "../../api";
import {FormControlLabel, MenuItem, Select} from "@mui/material";
import {Radio, RadioGroup} from '@material-ui/core';
import {toast, ToastContainer} from "react-toastify";
import AddIcon from "@mui/icons-material/Add";

function WorkersList() {
    const [workers, setWorkers] = useState([]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteWorkerId, setDeleteWorkerId] = useState(null);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [editWorkerId, setEditWorkerId] = useState(null);
    const [editWorkerName, setEditWorkerName] = useState('');
    const [editWorkerPhone, setEditWorkerPhone] = useState('');
    const [editWorkerFactoryId, setEditWorkerFactoryId] = useState('');
    const [editWorkerType, setEditWorkerType] = useState('');
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [newWorkerName, setNewWorkerName] = useState('');
    const [newWorkerFactoryId, setNewWorkerFactoryId] = useState('');
    const [newWorkerPhone, setNewWorkerPhone] = useState('');
    const [newWorkerType, setNewWorkerType] = useState('');
    const [factories, setFactories] = useState([]);

    const handleEditOpen = (workerId, workerName, workerPhone, workerType, workerFactoryId) => {
        setOpenEditDialog(true);
        setEditWorkerId(workerId);
        setEditWorkerName(workerName);
        setEditWorkerPhone(workerPhone);
        setEditWorkerType(workerType);
        setEditWorkerFactoryId(workerFactoryId);
    };
    const handleEditClose = () => {
        setOpenEditDialog(false);
        setEditWorkerId(null);
        setEditWorkerName('');
        setEditWorkerPhone('');
        setEditWorkerFactoryId('');
        window.location.reload();
    };
    const handleDeleteOpen = (workerId) => {
        setOpenDeleteDialog(true);
        setDeleteWorkerId(workerId);
    };
    const handleDeleteClose = () => {
        setOpenDeleteDialog(false);
        setDeleteWorkerId(null);
    };
    const handleEditSubmit = async () => {
        try {
            const response = await api.post(`/worker/${editWorkerId}`, {
                name: editWorkerName,
                mobile_number: p2e(editWorkerPhone),
                factory_id: editWorkerFactoryId,
                type: editWorkerType
            })
            handleEditClose();
        } catch (err) {
            toast.error(err.response.data.message)
        }
    };
    const handleDeleteSubmit = async () => {
        try {
            await api.delete(`/worker/${deleteWorkerId}`);
            setWorkers(workers.filter(worker => worker.id !== deleteWorkerId));
            handleDeleteClose();
        } catch (err) {
            toast.error(err.response.data.message)
        }
    };

    const handleCreateOpen = () => {
        setOpenCreateDialog(true);
    };

    const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))

    const createWorker = async (name, mobile_number, factory_id, type) => {
        console.log(type)
        try {
            const response = await api.post('/worker', {
                name: name,
                mobile_number: p2e(mobile_number),
                factory_id: factory_id,
                type: type
            })
                .then((res) => {
                    handleCreateClose()
                });
        } catch (err) {
            toast.error(err.response.data.message)
        }
    };

    const handleCreateClose = () => {
        setOpenCreateDialog(false);
        setNewWorkerName('');
        setNewWorkerPhone('');
        setNewWorkerFactoryId('');
        setNewWorkerType('');
        window.location.reload();
    };

    const handleCreateSubmit = async () => {
        if (
            !newWorkerName ||
            !newWorkerPhone ||
            !newWorkerFactoryId ||
            !newWorkerType
        ) {
            toast.error('لطفا همه ی فیلد های الزامی را پر کنید');
            return;
        }

        try {
            const response = await createWorker(newWorkerName, newWorkerPhone, newWorkerFactoryId, newWorkerType);
        } catch (err) {
            toast.error(err.message)
        }
    };

    useEffect(() => {
        const fetchWorkers = async () => {
            try {
                const response = await api.get('/worker');
                setWorkers(response.data.data);
            } catch (error) {
                console.log(error)
            }
        };
        fetchWorkers();

        async function fetchFactories() {
            try {
                const response = await api.get("/factory");
                setFactories(response.data.data);
            } catch (error) {
                toast.error(error.response.data.message)
            }
        }

        fetchFactories();
    }, []);

    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="card border-3 rounded-4 border-dark mb-4">
                            <div className="card-header bg-dark text-center">
                                <button
                                    className='btn btn-lg btn-dark fw-bold fs-5'
                                    onClick={handleCreateOpen}
                                >
                                    <AddIcon/> ایجاد همکار جدید
                                </button>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-hover table-striped table-bordered table-rounded"
                                           aria-label="simple table">
                                        <thead>
                                        <tr className="text-center shadow pb-4"
                                            style={{backgroundColor: 'var(--header-color)'}}>
                                            <th>نام و نام خانوادگی</th>
                                            <th>شماره موبایل</th>
                                            <th>نام شعبه</th>
                                            <th>شغل</th>
                                            <th>ویرایش</th>
                                            <th>حذف</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {workers.map((worker) => (
                                            <tr key={worker.id}>
                                                <td className="text-center">{worker.name}</td>
                                                <td className="text-center">{worker.mobile_number}</td>
                                                <td className="text-center">{worker.factory.name}</td>
                                                <td className="text-center">
                                                    {worker.type === "1" ? 'صافکار' : 'نقاش'}
                                                </td>
                                                <td className="text-center">
                                                    <IconButton color="primary"
                                                                onClick={() => handleEditOpen(worker.id, worker.name, worker.mobile_number, worker.type, worker.factory_id)}>
                                                        <Edit/>
                                                    </IconButton>
                                                </td>
                                                <td className="text-center">
                                                    <IconButton color="secondary"
                                                                onClick={() => handleDeleteOpen(worker.id)}>
                                                        <Delete/>
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <Dialog open={openDeleteDialog} onClose={handleDeleteClose}>
                            <DialogTitle className="bg-dark">
                                <p className="text-white">حذف کارمند</p>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    آیا مطمئن هستید که میخواهید کارمند را حذف کنید ؟
                                </DialogContentText>
                            </DialogContent>
                            <input className='btn btn-danger mx-5 mb-2 mt-3' type="submit"
                                   onClick={handleDeleteSubmit}
                                   value="حذف"
                            />
                            <input className='btn btn-secondary mx-5 mb-2' type='button'
                                   onClick={handleDeleteClose}
                                   value="انصراف"
                            />
                        </Dialog>
                        <Dialog open={openCreateDialog} onClose={handleCreateClose}>
                            <DialogTitle className="bg-dark">
                                <p className="text-white">ایجاد همکار جدید</p>
                            </DialogTitle>
                            <DialogContent>
                                <form onSubmit={handleCreateSubmit}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <label className='form-label'>نام و نام خانوادگی</label>
                                            <input
                                                id="name"
                                                className="form-control shadow"
                                                type="text"
                                                name="name"
                                                value={newWorkerName}
                                                onChange={event => setNewWorkerName(event.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>شماره موبایل</label>
                                            <input
                                                variant="outlined"
                                                required
                                                id="mobile_number"
                                                type="text"
                                                maxLength={11}
                                                className='form-control shadow'
                                                name="mobile_number"
                                                value={newWorkerPhone}
                                                onChange={event => setNewWorkerPhone(event.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>نوع همکاری</label>
                                            <RadioGroup
                                                row
                                                aria-label="type"
                                                name="type"
                                                value={newWorkerType}
                                                onChange={event => setNewWorkerType(event.target.value)}
                                            >
                                                <FormControlLabel
                                                    value="1"
                                                    control={<Radio/>}
                                                    label="صافکار"
                                                />
                                                <FormControlLabel
                                                    value="2"
                                                    control={<Radio/>}
                                                    label="نقاش"
                                                />
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label id="factory-id" className='form-label'>نام شعبه</label>
                                            <Select
                                                id="factory-id"
                                                value={newWorkerFactoryId}
                                                onChange={(event) => setNewWorkerFactoryId(event.target.value)}
                                                className='form-select'
                                            >
                                                {factories.map((factory) => (
                                                    <MenuItem key={factory.id} value={factory.id}>
                                                        {factory.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                            <input className='btn btn-warning mx-5 mb-2 mt-3' type="submit"
                                   onClick={handleCreateSubmit}
                                   value="ذخیره"
                            />
                            <input className='btn btn-secondary mx-5 mb-2' type='button'
                                   onClick={handleCreateClose}
                                   value="انصراف"
                            />
                        </Dialog>
                        <Dialog open={openEditDialog} onClose={handleEditClose}>
                            <DialogTitle className="bg-dark">
                                <p className="text-white">ویرایش اطلاعات</p>
                            </DialogTitle>
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <label className='form-label'>نام و نام خانوادگی</label>
                                        <input
                                            id="name"
                                            className="form-control shadow"
                                            type="text"
                                            value={editWorkerName}
                                            onChange={(event) => setEditWorkerName(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <label className='form-label'>شماره موبایل</label>
                                        <input
                                            variant="outlined"
                                            required
                                            id="mobile_number"
                                            type="text"
                                            maxLength={11}
                                            className='form-control shadow'
                                            name="mobile_number"
                                            value={editWorkerPhone}
                                            onChange={event => setEditWorkerPhone(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <label className='form-label'>نوع همکاری</label>
                                        <RadioGroup
                                            row
                                            aria-label="type"
                                            name="type"
                                            value={editWorkerType}
                                            onChange={(event) => setEditWorkerType(event.target.value)}
                                        >
                                            <FormControlLabel
                                                value="1"
                                                control={<Radio/>}
                                                label="صافکار"
                                            />
                                            <FormControlLabel
                                                value="2"
                                                control={<Radio/>}
                                                label="نقاش"
                                            />
                                        </RadioGroup>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <label id="factory-id" className='form-label'>نام شعبه</label>
                                        <Select
                                            id="factory-id"
                                            value={editWorkerFactoryId}
                                            onChange={(event) => setEditWorkerFactoryId(event.target.value)}
                                            className='form-select'
                                        >
                                            {factories.map((factory) => (
                                                <MenuItem key={factory.id} value={factory.id}>
                                                    {factory.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <input className='btn btn-warning mx-5 mb-2 mt-3' type="submit"
                                   onClick={handleEditSubmit}
                                   value="ذخیره"
                            />
                            <input className='btn btn-secondary mx-5 mb-2' type='button'
                                   onClick={handleEditClose}
                                   value="انصراف"
                            />
                        </Dialog>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default WorkersList;
